import { render, staticRenderFns } from "./PagesCreate.vue?vue&type=template&id=d776ffc6&scoped=true&"
import script from "./PagesCreate.vue?vue&type=script&lang=js&"
export * from "./PagesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d776ffc6",
  null
  
)

export default component.exports